const initialState = {
    responseOfficesList: [],
    responseOffice: [],
    responseOfficeProductRemove: [],
    responseOfficeParent: [],
    responseSperta: {},
    responseKaring: {},
    responseDuplicate: [],
    responsePayment: [],
    responseTagsList: [],
    responseOfficeHistory: [],
    responseAditionalOffice: [],
    responseAditionalOfficesList: [],
    responseCanalsList: [],
    responseCanal: [],

    errorOffice: false,
    errorProductRemove: false,
    errorOfficeList: false,

    responseHashExportOffices: [],
    responseUpdateReportOffices: [],
    responseCheckReportOffices: [],
    errorHashExportOffices: false,
    errorCheckReportOffices: false,
    errorUpdateReportOffices: false
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "OFFICES_RESPONSE_LIST":
            if (action.value.detail !== undefined) {
                newState.errorOfficeList = true;
            } else {
                newState.errorOfficeList = false;
            }
            newState.responseOfficesList = action.value;
            break;
        case "OFFICE_RESPONSE":
            newState.responseOffice = action.value;
            if (action.value.detail !== undefined) {
                newState.errorOffice = true;
            } else {
                newState.errorOffice = false;
            }
            break;
        case "OFFICE_PRODUCT_REMOVE_RESPONSE":
            newState.responseOfficeProductRemove = action.value;
            if (action.value.status === "ok") {
                newState.errorProductRemove = false;
            } else {
                newState.errorProductRemove = true;
            }
            break;
        case "OFFICE_PARENT_RESPONSE":
            newState.responseOfficeParent = action.value;
            break;
        case "ADITIONAL_OFFICE_RESPONSE":
            newState.responseAditionalOffice = action.value;
            break;
        case "ADITIONAL_OFFICE_LIST_RESPONSE":
            newState.responseAditionalOfficeList = action.value;
            break;
        case "PAYMENT_RESPONSE_HISTORY":
            newState.responseOfficeHistory = action.value;
            break;
        case "DUPLICATE_RESPONSE":
            newState.responseDuplicate = action.value;
            break;
        case "GET_SPERTA_OFFICE":
            newState.responseSperta = {};
            break;
        case "SPERTA_RESPONSE":
            newState.responseSperta = action.value;
            break;
        case "KARING_RESPONSE":
            newState.responseKaring = action.value;
            break;
        case "PAYMENT_RESPONSE":
            newState.responsePayment = action.value;
            break;
        case "TAGS_RESPONSE_LIST":
            if (action.value.detail !== undefined)
                newState.responseTagsList = []
            else
                newState.responseTagsList = action.value;
            break;
        case 'HASH_EXPORT_OFFICES_RESPONSE':
            newState.responseHashExportOffices = action.value;
            if (action.value.detail !== undefined) {
                newState.errorHashExportOffices = true;
            } else {
                newState.errorHashExportOffices = false;
            }
            break;
        case 'REPORT_EXPORT_OFFICES_RESPONSE':
            newState.responseCheckReportOffices = action.value;
            if (action.value.detail !== undefined) {
                newState.errorCheckReportOffices = true;
            } else {
                newState.errorCheckReportOffices = false;
            }
            break;
        case 'UPDATE_EXPORT_OFFICES_RESPONSE':
            newState.responseUpdateReportOffices = action.value;
            if (action.value.detail !== undefined) {
                newState.errorUpdateReportOffices = true;
            } else {
                newState.errorUpdateReportOffices = false;
            }
            break;
        case "OFFICES_RESPONSE_LIST_LIMITED":
            if (action.value.detail !== undefined) {
                newState.errorOfficeList = true;
            } else {
                newState.errorOfficeList = false;
            }
            newState.responseOfficesList = action.value;
            break;
        case "CANALES_LIST_RESPONSE":
            if (action.value.detail !== undefined) {
                newState.errorCanalList = true;
            } else {
                newState.errorCanalList = false;
            }
            newState.responseCanalsList = action.value;
            break;
        case "CANAL_RESPONSE":
            if (action.value.detail !== undefined) {
                newState.errorCanal = true;
            } else {
                newState.errorCanal = false;
            }
            newState.responseCanal = action.value;
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;